import App from "@frog/source/models/App.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import World from "@frog/source/models/World.js"

import convertOldChapterScripting from "@frog/source/data/games/hero/convertOldChapterScripting.js"

export default {
    "slug": "prologue",
    "stage": {
        "image": require("./image.png"),
        "imageOffset": {"x": -6, "y": -1},
        "units": require("./units.json"),
        "world": World.parse({
            "encounters": require("./encounters.json"),
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "width": 18,
            "height": 10,
        }),
        "conditions": convertOldChapterScripting({
            "0:start": [
                // {
                //     "type": "MoveUnit",
                //     "position": {x: 1, y: 4},
                //     "classKey": "#B",
                // },
                // {
                //     "type": "MoveUnit",
                //     "position": {x: 5, y: 3},
                //     "classKey": "#C",
                // },
                // {
                //     "type": "MoveUnit",
                //     "position": {x: 0, y: 1},
                //     "classKey": "#D",
                // },
                {
                    "type": "SpawnUnit",
                    "spawn": {
                        "key": "#1",
                        "position": {"x": 2, "y": 8},
                        "classKey": "archer",
                        "affiliation": "bad",
                    },
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 2, "y": 6},
                    "classKey": "#1",
                },
                {
                    "type": "SpawnUnit",
                    "spawn": {
                        "key": "#2",
                        "position": {"x": 4, "y": -1},
                        "classKey": "berserker",
                        "affiliation": "bad",
                    },
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 4, "y": 1},
                    "classKey": "#2",
                },
                {
                    "type": "SpawnUnit",
                    "spawn": {
                        "key": "francois",
                        "position": {"x": 6, "y": 6},
                        "classKey": "paladin",
                        "affiliation": "bad",
                        "health": 2
                    },
                },
                {
                    "type": "MoveUnit",
                    "position": {"x": 5, "y": 6},
                    "classKey": "francois",
                },
                {
                    "type": "DisplayDialogue",
                    "dialogue": {
                        "name": "Saul", "side": "right",
                        "text": "Commander Francois, flank them with our reinforcements!",
                    }
                },
                {
                    "type": "DisplayDialogue",
                    "dialogue": {
                        "name": "brigid",
                        "text": "There's too many of them!",
                        "expression": "frowny",
                    }
                },
                {
                    "type": "DisplayDialogue",
                    "dialogue": {
                        "name": "callista",
                        "text": "Oriana, what's our strategy?",
                        "expression": "stern",
                    }
                },
                {
                    "type": "DisplayDialogue",
                    "dialogue": {
                        "name": "Saul", "side": "right",
                        "text": "You fought well, but it was all in vain.",
                        "expression": "serene",
                    }
                },
                {
                    "type": "DisplayDialogue",
                    "dialogue": {
                        "name": "Saul", "side": "right",
                        "text": "Now perish.",
                        "expression": "sly",
                    }
                },
                {
                    "type": "DisplayDialogue",
                    "dialogue": {
                        "name": "oriana",
                        "text": "We need to retreat, we need-!",
                    }
                },
                // {
                //     "type": "StopDialogue",
                // },
                {
                    "type": "PlayStinger",
                    "sound": {
                        "name": "Final Hit",
                        "volume": 1,
                    }
                },
                {
                    "type": "TransitionScreen", "screen": "SplashScreen", "time": 1, "url": "/games/hero/chapters/introduce-mercenary",
                    // "type": "TransitionScreen", "screen": "GameScreen", "locationKey": "1"
                },
            ],
        })
    },
}

// "prologue": {
//     "isCutscene": true,
//     "hasPreparation": false,
//     "music": "evil",
//     "map": {
//         "width": 6,
//         "height": 8,
//         "image": require("@frog/source/assets/images/hero-tactics/stages/grasslands-castle.png"),
//         "tiles": [
//             {"position": {"x": 0, "y": 0}, "passable": false},
//             {"position": {"x": 1, "y": 0}, "passable": false},
//             {"position": {"x": 2, "y": 0}, "passable": false},
//             {"position": {"x": 3, "y": 0}, "passable": false},
//             {"position": {"x": 4, "y": 0}, "passable": false},
//             {"position": {"x": 5, "y": 0}, "passable": false},
//             {"position": {"x": 1, "y": 1}, "passable": false},
//             {"position": {"x": 2, "y": 1}, "passable": false},
//             {"position": {"x": 3, "y": 1}, "passable": false},
//             {"position": {"x": 0, "y": 3}, "passable": false},
//             {"position": {"x": 1, "y": 3}, "passable": false},
//             {"position": {"x": 3, "y": 3}, "passable": false},
//             {"position": {"x": 4, "y": 3}, "passable": false},
//             {"position": {"x": 1, "y": 5}, "passable": false},
//             {"position": {"x": 2, "y": 5}, "passable": false},
//             {"position": {"x": 4, "y": 5}, "passable": false},
//             {"position": {"x": 5, "y": 5}, "passable": false},
//             {"position": {"x": 1, "y": 6}, "passable": false},
//         ]
//     },
//     "spawns": [
//         {"position": {"x": 3, "y": 4}, "affiliation": "good"},
//         {"position": {"x": 4, "y": 4}, "affiliation": "good"},
//         {"position": {"x": 3, "y": 5}, "affiliation": "good"},
//         {"position": {"x": 3, "y": 2}, "affiliation": "bad", "classKey": "cleric", "key": "saul"},
//         {"position": {"x": 1, "y": 4}, "affiliation": "bad", "classKey": "berserker", "key": "#B"},
//         {"position": {"x": 5, "y": 3}, "affiliation": "bad", "classKey": "berserker", "key": "#C"},
//         {"position": {"x": 0, "y": 1}, "affiliation": "bad", "classKey": "archer", "key": "#D"},
//         // {"position": {x: -1, y: 4}, "affiliation": "bad", "classKey": "berserker", "key": "#B"},
//         // {"position": {x: 6, y: 3}, "affiliation": "bad", "classKey": "berserker", "key": "#C"},
//         // {"position": {x: 0, y: -1}, "affiliation": "bad", "classKey": "archer", "key": "#D"},
//     ],
//     "events": {
//         "0:start": [
//             // {
//             //     "type": "MoveUnit",
//             //     "position": {x: 1, y: 4},
//             //     "classKey": "#B",
//             // },
//             // {
//             //     "type": "MoveUnit",
//             //     "position": {x: 5, y: 3},
//             //     "classKey": "#C",
//             // },
//             // {
//             //     "type": "MoveUnit",
//             //     "position": {x: 0, y: 1},
//             //     "classKey": "#D",
//             // },
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "#1",
//                     "position": {"x": 2, "y": 8},
//                     "classKey": "archer",
//                     "affiliation": "bad",
//                 },
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 2, "y": 6},
//                 "classKey": "#1",
//             },
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "#2",
//                     "position": {"x": 4, "y": -1},
//                     "classKey": "berserker",
//                     "affiliation": "bad",
//                 },
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 4, "y": 1},
//                 "classKey": "#2",
//             },
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "francois",
//                     "position": {"x": 6, "y": 6},
//                     "classKey": "paladin",
//                     "affiliation": "bad",
//                     "health": 2
//                 },
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 5, "y": 6},
//                 "classKey": "francois",
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "Saul", "side": "right",
//                     "text": "Commander Francois, flank them with our reinforcements!",
//                 }
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "brigid",
//                     "text": "There's too many of them!",
//                 }
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "callista",
//                     "text": "oriana, what's our strategy?",
//                 }
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "Saul", "side": "right",
//                     "text": "You fought well, but it was all in vain.",
//                 }
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "Saul", "side": "right",
//                     "text": "Now perish.",
//                 }
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "oriana",
//                     "text": "We need to retreat, we need-!",
//                 }
//             },
//             // {
//             //     "type": "StopDialogue",
//             // },
//             {
//                 "type": "PlayStinger",
//                 "sound": {
//                     "name": "Final Hit",
//                     "volume": 1,
//                 }
//             },
//             {
//                 "type": "TransitionScreen", "screen": "SplashScreen", "time": 1, "url": "/games/hero/chapters/introduce-mercenary",
//                 // "type": "TransitionScreen", "screen": "GameScreen", "locationKey": "1"
//             },
//         ],
//     },
// },
